
import { EntityConfig } from './types';

export const GOAL_CONFIG: EntityConfig = {
  entityType: 'goal',
  tableName: 'goal_research_attachments',
  entityIdColumn: 'goal_id',
  researchLimit: 3,
  queryKey: ['goal-attached-research'],
  displayName: 'Goal Research'
};
